import { render, staticRenderFns } from "./QualityKPIChart.vue?vue&type=template&id=25cf7226&"
import script from "./QualityKPIChart.vue?vue&type=script&lang=js&"
export * from "./QualityKPIChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports